import {
  DEFAULT_TIME_ZONE,
  eventFromRow,
  localDate,
  signingDatePhrase,
} from "../../../../../shared/events/index.js";

const MONTH = new Intl.DateTimeFormat("en-US", {
  month: "short",
  timeZone: "UTC",
});

const badgeDateOf = (event) =>
  event.dateType === "Range"
    ? event.eventStartDate
    : localDate(event.nextEventTime, event.timeZone ?? DEFAULT_TIME_ZONE);

export const offCameraDates = (row) => {
  const event = eventFromRow(row);
  const date = badgeDateOf(event);

  return {
    month: MONTH.format(new Date(`${date}T00:00:00.000Z`)),
    day: String(Number(date.slice(8, 10))),
    dateTime: date,
    text: `Signed off camera ${signingDatePhrase(event)}`,
  };
};
